import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { SUPPORT_NAV } from './nav';

interface AgentRow { agent: string; agent_id: number; assigned_count: number; resolved_count: number; avg_resolution_hours: number | null; }

const AgentPerformance: React.FC = () => {
    const { api } = useInternalApi();
    const [rows, setRows] = useState<AgentRow[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Agent Performance - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('admin-dashboard/support/agent-performance/').then(res => {
            if (res.data?.status === 'success') setRows(res.data.data || []);
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="support_center" subNav={SUPPORT_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faUserTie} className="me-2 text-primary" />Agent Performance</h2>
            <p className="text-muted mb-4">Ticket workload and resolution times per agent, last 30 days</p>

            <div className="card border-0 shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
                    ) : rows.length === 0 ? (
                        <div className="text-center py-5 text-muted">No tickets have been assigned to an agent in the last 30 days.</div>
                    ) : (
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light"><tr><th>Agent</th><th>Assigned</th><th>Resolved</th><th>Resolution Rate</th><th>Avg Time to Resolve</th></tr></thead>
                            <tbody>
                                {rows.map(r => {
                                    const rate = r.assigned_count ? Math.round((r.resolved_count / r.assigned_count) * 100) : 0;
                                    return (
                                        <tr key={r.agent_id}>
                                            <td>{r.agent}</td>
                                            <td>{r.assigned_count}</td>
                                            <td>{r.resolved_count}</td>
                                            <td>
                                                <div className="progress" style={{ height: 6, width: 100 }}>
                                                    <div className="progress-bar bg-success" style={{ width: `${rate}%` }} />
                                                </div>
                                                <span className="small text-muted">{rate}%</span>
                                            </td>
                                            <td>{r.avg_resolution_hours !== null ? `${r.avg_resolution_hours}h` : '—'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </InternalShell>
    );
};

export default AgentPerformance;
